import { AssetEntityModel } from "src/store/models/entity/asset/entity";
import { AssetHelperModel } from "src/store/models/entity/asset/helper";

export const encooAssetModels = {
  entity: AssetEntityModel,
  helper: AssetHelperModel,
};
